module.exports = __webpack_public_path__ + "img/social-city-billboard.cde09722.jpg";